export interface FaqItem {
  q: string;
  a: string;
}

export interface FaqSection {
  title: string;
  items: FaqItem[];
}

export const FAQ_SECTIONS: FaqSection[] = [
  {
    title: "Billing",
    items: [
      {
        q: "How are members billed?",
        a: "Each non-owner member adds $2/month to the organization's bill. The organization's owner is billed on behalf of the org.",
      },
      {
        q: "What happens to my bill if a member leaves mid-cycle?",
        a: "The current bill stays the same for the remainder of the cycle - it is based on the maximum number of members during the cycle. Removing someone reduces your next cycle's bill, not the current one. So if a member leaves and another joins later in the same cycle, your current bill does not change.",
      },
      {
        q: "How is task usage billed?",
        a: "We bill $2 per 100 tasks created during a billing cycle. The charge for the just-completed cycle's task usage rolls into the next renewal invoice.",
      },
      {
        q: "Can I cancel?",
        a: "Yes. Your subscription stays active until the end of the current billing period, then drops back to the free plan.",
      },
    ],
  },
  {
    title: "Account & organization deletion",
    items: [
      {
        q: "How do I delete my account?",
        a: "From the Account settings page. If you are the sole owner of any organization, you will be prompted to transfer ownership to another member first.",
      },
      {
        q: "What happens when I delete an organization?",
        a: "The organization enters a pending deletion state through the end of the current billing period. During that window it cannot create projects or invite members, and you can cancel the deletion. After the period ends, all projects, tasks, and memberships are removed.",
      },
    ],
  },
  {
    title: "Roles",
    items: [
      {
        q: "What can each role do?",
        a: "**Owner**: manage billing, transfer org ownership, delete the org, manage members and admins, delete any project or task.\n\n**Admin**: invite/remove members, delete projects, delete any task.\n\n**Member**: leave the org and delete tasks they created.",
      },
    ],
  },
  {
    title: "Tasks",
    items: [
      {
        q: "What happens to a task stuck IN_PROGRESS?",
        a: "If a task stays `IN_PROGRESS` for more than 24 hours without progress, it is automatically returned to `PENDING` and a timeline entry records the timeout.",
      },
    ],
  },
];

export function buildFaqPageSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQ_SECTIONS.flatMap((section) =>
      section.items.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: {
          "@type": "Answer",
          text: item.a,
        },
      })),
    ),
  };
}
